function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "zoomOut",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-/-search"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "edit-/-search-(Background/Mask)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,3 C14.6421356,3 18,6.35786438 18,10.5 C18,14.6421356 14.6421356,18 10.5,18 C6.35786438,18 3,14.6421356 3,10.5 C3,6.35786438 6.35786438,3 10.5,3 Z M10.5,5 C7.46243388,5 5,7.46243388 5,10.5 C5,13.5375661 7.46243388,16 10.5,16 C13.5375661,16 16,13.5375661 16,10.5 C16,7.46243388 13.5375661,5 10.5,5 Z",
  id: "Oval-Copy",
  fill: "#555555",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-Copy",
  fill: "#555555",
  fillRule: "nonzero",
  points: "15.0857864 16.5 16.5 15.0857864 22.4142136 21 21 22.4142136"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(8.500000, 9.500000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3-Copy",
  points: "5 0 5 2 -1 2 -1 0"
})));

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zoomOut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.dc32fb79.svg";
export { ForwardRef as ReactComponent };